import React from 'react'

import styles from './CenteredForm.module.css'

interface CenteredFormProps {
  navMenu?: React.ReactNode
}

const CenteredForm: React.FC<CenteredFormProps> = ({ children, navMenu }) => (
  <div className={styles.centeredForm}>
    {children}
    {navMenu && <div className={styles.navMenu}>{navMenu}</div>}
  </div>
)

export default CenteredForm
